<template>
  <transition>
    <div
      v-if="filterToggle"
      class="pt-2"
    >
      <b-form
        class="border-dashed"
      >
        <b-row>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.DC_TYPE))"
              :label-for="ApplyDocument.DC_TYPE"
            >
              <v-select
                :id="ApplyDocument.DC_TYPE"
                v-model="filters[ApplyDocument.DC_TYPE]"
                multiple
                :reduce="(option) => option.id"
                :options="dcTypes"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.STATUS))"
              :label-for="ApplyDocument.STATUS"
            >
              <v-select
                :id="ApplyDocument.STATUS"
                v-model="filters[ApplyDocument.STATUS]"
                :reduce="(option) => option.id"
                :options="applyDocumentStatuses"
                :get-option-label="(option) => $langName(option.name)"
                :multiple="true"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="isInno"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.IS_MY_GOV))"
              :label-for="ApplyDocument.IS_MY_GOV"
            >
              <v-select
                :id="ApplyDocument.IS_MY_GOV"
                v-model="filters[ApplyDocument.IS_MY_GOV]"
                :reduce="(option) => option.id"
                :options="applicationSources"
                :get-option-label="(option) => $t(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="isInno"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.REGION))"
              :label-for="ApplyDocument.REGION"
            >
              <v-select
                :id="ApplyDocument.REGION"
                v-model="filters[ApplyDocument.REGION]"
                :reduce="(option) => option.id"
                :options="regions"
                :placeholder="$t('All')"
                :get-option-label="(option) => $langName(option.name)"
                @input="regionSelect"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="isInno"
            md="4"
          >
            <b-form-group
              :label="$t('Education organizations')"
              :label-for="ApplyDocument.ORGANIZATION"
            >
              <v-select
                :id="ApplyDocument.ORGANIZATION"
                v-model="filters[ApplyDocument.ORGANIZATION]"
                :reduce="(option) => option.id"
                :options="universityList"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
                @input="selectDirections"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="directions.length"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.DIRECTION))"
              :label-for="ApplyDocument.DIRECTION"
            >
              <v-select
                :id="ApplyDocument.DIRECTION"
                v-model="filters[ApplyDocument.DIRECTION]"
                :reduce="(option) => option.id"
                :options="directions"
                :get-option-label="(option) => option.code + ' - ' + $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="isInno"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.IS_PRIORITY))"
              :label-for="ApplyDocument.IS_PRIORITY"
            >
              <v-select
                :id="ApplyDocument.IS_PRIORITY"
                v-model="filters[ApplyDocument.IS_PRIORITY]"
                :reduce="(option) => option.id"
                :options="yesNoOptions"
                :get-option-label="(option) => option.name"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="4"
          >
            <b-form-group
              v-if="periods.length > 0"
              :label="$t(filterClass.getLabel(ApplyDocument.PERIOD))"
              :label-for="ApplyDocument.PERIOD"
            >
              <v-select
                id="period"
                v-model="filters[ApplyDocument.PERIOD]"
                :options="periods"
                :get-option-label="(option) => option.admission_year + '-' + option.name"
                :placeholder="$t('All')"
                @input="selectQuarter"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="filters[ApplyDocument.PERIOD]"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.QUARTER))"
              :label-for="ApplyDocument.QUARTER"
            >
              <v-select
                :id="ApplyDocument.QUARTER"
                v-model="filters[ApplyDocument.QUARTER]"
                :reduce="(option) => option.id"
                :options="filters[ApplyDocument.PERIOD].quarters"
                :get-option-label="(option) => option.quarter"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.GENDER))"
              :label-for="ApplyDocument.GENDER"
            >
              <v-select
                :id="ApplyDocument.GENDER"
                v-model="filters[ApplyDocument.GENDER]"
                :reduce="(option) => option.id"
                :options="genders"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.SCHOLARSHIP_STATUS))"
              :label-for="ApplyDocument.SCHOLARSHIP_STATUS"
            >
              <v-select
                :id="ApplyDocument.SCHOLARSHIP_STATUS"
                v-model="filters[ApplyDocument.SCHOLARSHIP_STATUS]"
                :reduce="(option) => option.id"
                :options="scholarshipStatus"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.ADVISOR))"
              :label-for="ApplyDocument.ADVISOR"
            >
              <v-select
                :id="ApplyDocument.ADVISOR"
                :value="filters[ApplyDocument.ADVISOR]"
                :options="advisorList"
                :reduce="(option) => option.id"
                :get-option-label="(option) => option.full_name"
                :placeholder="$t('All')"
                @search="fetchAdvisor"
                @input="inputAdvisor"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.COURSE))"
              :label-for="ApplyDocument.COURSE"
            >
              <v-select
                :id="ApplyDocument.COURSE"
                v-model="filters[ApplyDocument.COURSE]"
                :options="[1,2,3]"
                :multiple="true"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="isInno"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.MONITORING_1))"
              :label-for="ApplyDocument.MONITORING_1"
            >
              <v-select
                :id="ApplyDocument.MONITORING_1"
                v-model="filters[ApplyDocument.MONITORING_1]"
                :reduce="(option) => option.id"
                :options="checkMonitoringStatus"
                :get-option-label="(option) => $langName(option)"
                :multiple="true"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="isInno"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.MONITORING_2))"
              :label-for="ApplyDocument.MONITORING_2"
            >
              <v-select
                :id="ApplyDocument.MONITORING_2"
                v-model="filters[ApplyDocument.MONITORING_2]"
                :reduce="(option) => option.id"
                :options="checkMonitoringStatus"
                :get-option-label="(option) => $langName(option)"
                :multiple="true"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="isInno"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.MONITORING_3))"
              :label-for="ApplyDocument.MONITORING_3"
            >
              <v-select
                :id="ApplyDocument.MONITORING_3"
                v-model="filters[ApplyDocument.MONITORING_3]"
                :reduce="(option) => option.id"
                :options="checkMonitoringStatus"
                :get-option-label="(option) => $langName(option)"
                :multiple="true"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.IS_OLD))"
              :label-for="ApplyDocument.IS_OLD"
            >
              <v-select
                :id="ApplyDocument.IS_OLD"
                v-model="filters[ApplyDocument.IS_OLD]"
                :reduce="(option) => option.id"
                :get-option-label="(option) => $t(option.name)"
                :options="isOldList"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(ApplyDocument.IS_OLD_CONFIRM))"
              :label-for="ApplyDocument.IS_OLD_CONFIRM"
            >
              <v-select
                :id="ApplyDocument.IS_OLD_CONFIRM"
                v-model="filters[ApplyDocument.IS_OLD_CONFIRM]"
                :reduce="(option) => option.id"
                :get-option-label="(option) => $t(option.name)"
                :options="isOldConfirmList"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-button
              class="mr-1"
              variant="success"
              @click="onFilter"
            >
              <feather-icon icon="LFilterIcon" />
              {{ $t('Filter') }}
            </b-button>
            <b-button
              v-if="this.$route.meta.isInno"
              variant="primary"
              @click="onGenerateExel"
            >
              <feather-icon
                icon="LFilterIcon"
              />
              {{ $t('Excel generate') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </transition>
</template>

<script>
import vSelect from 'vue-select'
import {
  BButton, BCol, BForm, BFormGroup, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { isObject } from '@core/utils/utils'
import ApplyDocument from '@/views/components/filters/service/ApplyDocument'
import axios from '@/libs/axios'

export default {
  name: 'FilterComponent',
  components: {
    BForm,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    filterToggle: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: [Array, Object],
      default: () => ({}),
    },
    filterClass: {
      type: [Object, null],
      default: null,
    },
    selectedFilters: {
      type: [Array],
      default: () => ([]),
    },
  },
  data() {
    return {
      period: null,
      advisors: [],
      selectedAdvisor: null,
      applicationSources: [
        { id: 'false', name: 'Via main website' },
        { id: 'true', name: 'Via MyGov' },
      ],
      isOldList: [
        {
          id: '100',
          name: 'OLD_LIST',
        },
        {
          id: '200',
          name: 'NOT_OLD_LIST',
        },
      ],
      isOldConfirmList: [
        {
          id: '100',
          name: 'OLD_CONFIRM_LIST',
        },
        {
          id: '200',
          name: 'NOT_OLD_CONFIRM_LIST',
        },
      ],
      yesNoOptions: [
        { id: true, name: this.$t('Yes') },
        { id: false, name: this.$t('No') },
      ],
    }
  },
  computed: {
    ApplyDocument() {
      return ApplyDocument
    },
    dcTypes() {
      return this.$store.state.staticModule.dcTypes
    },
    applyDocumentStatuses() {
      return this.$store.state.staticModule.applyDocumentStatuses
    },
    regions() {
      return this.$store.state.staticModule.regions
    },
    universityList() {
      return this.$store.state.staticModule.universityList
    },
    researchAdvisors() {
      return this.$store.state.staticModule.researchAdvisors
    },
    directions() {
      return this.$store.state.staticModule.directionList
    },
    periods() {
      return this.$store.state.period.periods
    },
    genders() {
      return this.$store.state.staticModule.genders
    },
    checkMonitoringStatus() {
      return this.$store.state.staticModule.checkMonitoringAllStatus
    },

    scholarshipStatus() {
      return this.$store.state.staticModule.scholarshipStatuses
    },
    advisorList() {
      if (this.selectedAdvisor && !this.advisors.find(x => x.id === this.selectedAdvisor.id)) {
        return [this.selectedAdvisor, ...this.advisors]
      }
      return this.advisors
    },
    isInno() {
      return this.$route.meta.isInno
    },
  },
  watch: {
    regions(newValue) {
      this.changeValue(newValue, ApplyDocument.REGION)
    },
    periods(newValue) {
      this.changeValue(newValue, ApplyDocument.PERIOD)
      if (this.filters[ApplyDocument.PERIOD]?.quarters) this.changeValue(this.filters[ApplyDocument.PERIOD].quarters, ApplyDocument.QUARTER)
    },
    directions(newValue) {
      this.changeValue(newValue, ApplyDocument.DIRECTION)
    },
  },
  created() {
    this.filters[ApplyDocument.ORGANIZATION] = this.filters[ApplyDocument.ORGANIZATION] ? Number(this.filters[ApplyDocument.ORGANIZATION]) : null
    this.fetchAdvisor('', () => {})
    if (this.isInno) {
      this.regionSelect(this.filters[ApplyDocument.REGION])
    }
    if (this.filters[ApplyDocument.ADVISOR]) {
      this.filters[ApplyDocument.ADVISOR] = Number(this.filters[ApplyDocument.ADVISOR])
      this.setSelectedUser()
    }
    this.changeValue(this.genders, ApplyDocument.GENDER)
    this.changeValueMultiple(ApplyDocument.DC_TYPE)
    this.changeValueMultiple(ApplyDocument.STATUS)
    this.changeValueMultiple(ApplyDocument.COURSE)
    this.changeValueMultiple(ApplyDocument.MONITORING_1)
    this.changeValueMultiple(ApplyDocument.MONITORING_2)
    this.changeValueMultiple(ApplyDocument.MONITORING_3)
    this.changeValue(this.yesNoOptions, ApplyDocument.IS_PRIORITY)
    this.changeValue(this.applicationSources, ApplyDocument.IS_MY_GOV)
    this.selectDirections(this.filters[ApplyDocument.ORGANIZATION])
  },
  methods: {
    selectDirections(id) {
      if (id) {
        this.$store.dispatch('staticModule/directionList', { org_id: id })
      } else {
        this.$store.commit('staticModule/SET_DIRECTION_LIST', [])
        this.filters[ApplyDocument.DIRECTION] = null
      }
    },
    regionSelect(value) {
      this.$store.commit('staticModule/SET_UNIVERSITY_LIST', [])
      this.$store.dispatch('staticModule/universityList', { region: value }).then(({ data }) => {
        if (!data.find(item => item.id === this.filters[ApplyDocument.ORGANIZATION])) {
          this.filters[ApplyDocument.ORGANIZATION] = null
          this.selectDirections(null)
        }
      })
    },
    selectQuarter() {
      this.filters[ApplyDocument.QUARTER] = null
    },
    onFilter() {
      this.$emit('onFilter', this.filterClass.convertToQuery(this.filters))
    },
    onGenerateExel() {
      this.$emit('onGenerateExel', this.filterClass.convertToQuery(this.filters), ApplyDocument.EXEL_GENERATE_ENDPOINT)
    },
    changeValue(newValue, field) {
      if (newValue.length && this.filters[field] !== null && this.filters[field] !== undefined && !isObject(this.filters[field])) {
        this.filters[field] = newValue.find(x => `${x.id}` === `${this.filters[field]}`)
      }
    },
    changeValueMultiple(field) {
      if (Array.isArray(this.filters[field])) {
        this.filters[field] = this.filters[field].map(x => Number(x))
      } else if (this.filters[field]) {
        this.filters[field] = [Number(this.filters[field])]
      }
    },
    fetchAdvisor(search, loading) {
      loading(true)
      this.$store.dispatch('staticModule/researchAdvisors', { search }).then(res => {
        this.advisors = res
        loading(false)
      })
    },
    setSelectedUser() {
      axios.get(`auth/users/${this.filters[ApplyDocument.ADVISOR]}`).then(({ data }) => {
        this.selectedAdvisor = data
      })
    },
    inputAdvisor(id) {
      this.selectedAdvisor = this.advisors.find(x => x.id === id)
      this.filters[ApplyDocument.ADVISOR] = id
    },
  },
}
</script>

<style scoped>

</style>
